import React from 'react';
import classnames from 'classnames';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { hasPermission } from '../../../../store/apiWrapper';
import { isNullOrUndefined } from '../../../../store/storeFunctions';
import { OpenChart, OpenChartCug } from '../../../reportSections/iTrade/openChart';
import BandTable from '../../../reportSections/iTrade/bandTable';
import Summary from '../../../reportSections/iTrade/summary';
import CugTable from '../../../reportSections/iTrade/cug';
import Gradient from '../../../reportSections/iTrade/gradient';
import ITradeChart from '../../../reportSections/iTrade/iTradeChart';
import ITradeLineChart from '../../../reportSections/iTrade/iTradeLineChart';
import ITradeChartLegend from '../../../reportSections/iTrade/iTradeChartLegend';
import ITradeLineChartLegend from '../../../reportSections/iTrade/iTradeLineChartLegend';
import SanitizedLink from '../../../common/sanitizedLink';

import './invoices.scss';

const tabMenu = {
    summary: "summary",
    analyse: "analyse",
    lineChart: "lineChart"
};

class Invoices extends React.Component {
    state = {
        selected: tabMenu.summary
    };

    render() {
        if (isNullOrUndefined(this.props.data) || (!hasPermission(null, 'REPIITrade') && this.props.sections))
            return null;
        return this.renderWithData(this.props.data);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return ((this.props.dataHash !== nextProps.dataHash) || (this.state.selected !== nextState.selected));
    }

    renderWithData = (data) => {
        const lastUpdate = get(data, "summary.calculatedOnFormatted");

        if (data.showOffer)
            return this.renderOffer(data.offerUrl);

        return (
            <>
                {this.props.sections && <div className="repi-subsection-header repi-section-last-update-wrapper repi-payment-history-1em-wrapper">
                    <div><Translate id="Repi.Report.PaymentHistory.ITradeInvoices" /></div>
                    {!isNullOrUndefined(lastUpdate) && this.props.sections && <div className="repi-last-update">
                        <Translate id="Repi.Report.LastUpdate" />:&nbsp;{lastUpdate}
                    </div>}
                </div>}
                <div className="repi-list-of-applications repi-payment-history-1em-wrapper">
                    <div className="container">
                        {data.availability.isAvailable
                            ? this.props.sections
                                ? this.renderITradeSections(data)
                                : this.renderITrade(data, lastUpdate)
                            : this.renderNotAvailable()}
                    </div>
                </div>
            </>
        )
    }

    renderITrade = (data, lastUpdate) => {
        return (
            <>
                <div className="repi-subsection-header repi-section-last-update-wrapper">
                    <div><Translate id="Repi.Report.PaymentHistory.ITradeInvoices.Summary" /></div>
                    {!isNullOrUndefined(lastUpdate) && <div className="repi-last-update">
                        <Translate id="Repi.Report.LastUpdate" />:&nbsp;{lastUpdate}
                    </div>}
                </div>
                {this.renderITradeSummary(data)}
                <span className="repi-subsection-header"><Translate id="Repi.Report.PaymentHistory.ITradeInvoices.Analyse" /></span>
                <div className="transaction-analysis-root w-100" style={{ marginBottom: "20px" }}>
                    {this.renderITradeAnalysis(data)}
                </div>
                <span className="repi-subsection-header"><Translate id="Repi.Report.PaymentHistory.ITradeInvoices.LineChart" /></span>
                <div className="transaction-analysis-root w-100">
                    {this.renderITradeLineChart(data)}
                </div>
            </>
        )
    }

    renderITradeSections = (data) => {
        return (
            <>
                <div className="tabs tabs-section">
                    <ul>
                        <li className={`tab-link ${this.state.selected === tabMenu.summary ? "is-active" : ""}`}>
                            <a onClick={() => this.selectMenu(tabMenu.summary)}><Translate id="Repi.Report.PaymentHistory.ITradeInvoices.Summary" /></a>
                            <div className="search-progress-short" style={{ display: this.state.selected === tabMenu.summary ? "" : "none" }}></div>
                        </li>
                        <li className={`tab-link ${this.state.selected === tabMenu.analyse ? "is-active" : ""}`}>
                            <a onClick={() => this.selectMenu(tabMenu.analyse)}><Translate id="Repi.Report.PaymentHistory.ITradeInvoices.Analyse" /></a>
                            <div className="search-progress-short" style={{ display: this.state.selected === tabMenu.analyse ? "" : "none" }}></div>
                        </li>
                        <li className={`tab-link ${this.state.selected === tabMenu.lineChart ? "is-active" : ""}`}>
                            <a onClick={() => this.selectMenu(tabMenu.lineChart)}><Translate id="Repi.Report.PaymentHistory.ITradeInvoices.LineChart" /></a>
                            <div className="search-progress-short" style={{ display: this.state.selected === tabMenu.lineChart ? "" : "none" }}></div>
                        </li>
                    </ul>
                </div>
                {this.state.selected === tabMenu.summary && this.renderITradeSummary(data)}
                {this.state.selected === tabMenu.analyse && this.renderITradeAnalysis(data)}
                {this.state.selected === tabMenu.lineChart && this.renderITradeLineChart(data)}
            </>
        )
    }

    renderITradeSummary = (data) => {
        return (
            <div className="itrade-root">
                <div className="columns is-desktop is-multiline is-centered">
                    <div className="column is-7">
                        <div className="itrade-summary-root" style={{ minHeight: "250px" }}>
                            <Summary
                                data={data.summary}
                                extended={data.extended}
                                enhancements={data.cugEnhancement}
                                isITradeContributor={true}
                                isITradeUnlimited={data.isCugMember}
                            />
                        </div>
                    </div>
                    <div className="column is-5">
                        <div className="itrade-gradient-root">
                            <Gradient isRepi={true} index={data.summary.index}
                                avgIndex={data.availability.avgTradeIndex}
                                index0={data.indexes.index0}
                                index1={data.indexes.index1}
                                index2={data.indexes.index2}
                                min={data.indexes.min}
                                max={data.indexes.max}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderITradeAnalysis = (data) => {
        const displayBarChart = data.bands.map(x => x.total).reduce((a, b) => a + b, 0) > 0;

        return (
            <div className="itrade-root">
                <OpenChart data={data.extended}
                    xLabel={this.props.translate("Report.Itrade.DelayDays")}
                    yLabel={this.props.translate("Report.ITrade.PercentageOfTotalOwing")} />
                <br className="hide-on-desktop" />
                {this.cugHasData(data.cugEnhancement) && <>
                    <OpenChartCug data={data.cugEnhancement.find(x => !x.isHistorical && !x.isContributor)}
                        xLabel={this.props.translate("Report.Itrade.DelayDays")}
                        yLabel={this.props.translate("Report.ITrade.PercentageOfTotalOwing")} />
                    <CugTable data={data.cugEnhancement} currency={data.summary.currency} isHistorical={false} />
                    <CugTable data={data.cugEnhancement} currency={data.summary.currency} isHistorical={true} />
                    <br className="hide-on-desktop" />
                </>}
                {(displayBarChart || (Array.isArray(data.bands) && data.bands.length > 0)) && <>
                    {displayBarChart && <div className="itrade-chart">
                        <ITradeChart data={data.bands}
                            yLabel={this.props.translate("Repor.Itrade.PercentageInvoicedVolume")}
                            header={this.props.translate("Report.Itrade.PaymentAnalysis")}
                            xLabel={this.props.translate("Report.Itrade.DelayDays")}
                        >
                        </ITradeChart>
                        <ITradeChartLegend data={data.bands} currency={data.summary.currency} />
                    </div>}
                    {(Array.isArray(data.bands) && data.bands.length > 0) && <div className="itrade-table">
                        <BandTable bands={data.bands} currency={data.summary.currency} />
                    </div>}
                </>}
            </div>
        );
    }

    renderITradeLineChart = (data) => {
        return (
            <div className="itrade-root">
                {(Array.isArray(data.periods) && data.periods.length > 0) && <div className="itrade-line-chart">
                    <ITradeLineChart isRepi={true} label={this.props.translate("Repi.Report.ITradeIndex")}
                        data={data.periods} />
                    <ITradeLineChartLegend
                        iTrade={this.props.translate("Repi.Report.Itrade.SubjectIndex")}
                        avgTrade={this.props.translate("Repi.Report.Itrade.SectorPaymentTrend")} />
                </div>}
            </div>
        );
    }

    renderNotAvailable = () => {
        const mail = "helpdesk@repi.cz";
        const web = this.props.user.authentication.profile.agentLanguage === "sk-SK" ? "https://www.cribis.sk/" : "https://www.mcribis.cz/";

        return (
            <div className="itrade-not-available">
                <p><Translate id="Report.Itrade.NotAvailable" /> <Translate id="Report.Itrade.NotAvailable3" /></p>
                <br />
                <span className="underlined-title-wrapper underlined-title-wrapper-margin-bottom">
                    <h5 className="underlined-title rb-header">
                        <Translate id="Report.Itrade.NotAvailable2" />
                    </h5>
                </span>
                <p><Translate id="Report.Itrade.NotAvailable6" /></p>
                <br />
                <p>
                    <span>
                        <Translate id="Report.Itrade.NotAvailable4" />
                        <a
                            className={classnames("link-internal", { "is-normal": localStorage.locales_url_format === "normal" })}
                            href={web}
                            onClick={e => window.location = web}
                        >
                            <Translate id={"LeftPanel.iTrade"} />
                        </a>.&nbsp;
                        <Translate id="Report.Itrade.NotAvailable5" />
                        <a
                            className={classnames("link-internal", { "is-normal": localStorage.locales_url_format === "normal" })}
                            href={`mailto:${mail}`}
                        >
                            {mail}.
                        </a>
                    </span>
                </p>
            </div>
        )
    }

    renderOffer = (url) => {
        return (
            <div>
                <Translate id="Report.Common.Section.Nonactivated.Desc" />
                &nbsp;
                <SanitizedLink link={url} label={`${this.props.translate("Report.Common.More")}...`} />
            </div>
        );
    }

    cugHasData = (data) => {
        if (data.length === 0) { return false; }
        return data.map(x => x.openTotal).reduce((acc, cur) => acc + cur) > 0;
    }

    selectMenu = (value) => this.setState({ selected: value });
}

export default withLocalize(connect(
    state => { return { user: state.userContext } }
)(Invoices));
